import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { Eyebrow, Reveal } from "@/components/Motion";
import { Seo } from "@/components/Seo";
import { apiFetch } from "@/lib/api";

const groups = [
  {
    title: "Explore",
    links: [
      ["Home", "/"],
      ["Wealth Management", "/wealth-management"],
      ["Investment Solutions", "/investment-solutions"],
      ["About Us", "/about"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy-policy"],
      ["Terms of Use", "/terms-of-use"],
      ["Investment Disclaimer", "/investment-disclaimer"],
      ["Risk Disclosures", "/risk-disclosures"],
    ],
  },
];

export default function SitemapPage() {
  const { data } = useQuery({ queryKey: ["sitemap-insights"], queryFn: () => apiFetch("/articles?limit=20") });
  const insightLinks = [["All Insights", "/insights"], ...(data?.items || []).map((article) => [article.title, `/insights/${article.slug}`])];

  return <>
    <Seo title="Sitemap | Baaz Capital" description="Explore every public section of the Baaz Capital website, including wealth management, investment solutions, Insights, company information and legal pages." path="/sitemap" noIndex />
    <section className="sitemap-hero"><div className="shell"><Eyebrow>Website directory</Eyebrow><h1 data-testid="sitemap-heading">Find your way<br />around Baaz Capital.</h1><p data-testid="sitemap-introduction">A simple directory of our services, perspectives, company information and important policies.</p></div></section>
    <section className="sitemap-content shell" data-testid="public-sitemap">
      <div className="sitemap-grid">
        {[groups[0], { title: "Insights", links: insightLinks }, groups[1]].map((group, groupIndex) => <Reveal className="sitemap-group" delay={groupIndex * .07} key={group.title}>
          <span>0{groupIndex + 1}</span><h2 data-testid={`sitemap-${group.title.toLowerCase()}-heading`}>{group.title}</h2>
          <nav aria-label={`${group.title} sitemap links`}>{group.links.map(([label, path], linkIndex) => <Link key={path} to={path} data-testid={`sitemap-${group.title.toLowerCase()}-${linkIndex + 1}-link`}><span>{label}</span><ArrowRight size={16} /></Link>)}</nav>
        </Reveal>)}
      </div>
    </section>
  </>;
}